import { createSlice } from "@reduxjs/toolkit";

const initialState = { promoTemplate: [] };
const httpSlice = createSlice({
  name: "http",
  initialState,
  reducers: {
    addPromoItems(state, action) {
      state.promoData = action.payload
    },
    setPromoTemplate(state, { payload }) {
      state.promoTemplate = payload;
    },
  },
});

export default httpSlice.reducer;
export const httpActions = httpSlice.actions;

export const getData = (params) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const configResponse = await fetch(
        process.env.PUBLIC_URL + "/config/index.json"
      );
      if (!configResponse.ok) throw new Error("Something went wrong");
      const config = await configResponse.json();

      const response = await fetch(process.env.REACT_APP_SERVER + config.url + params + `&size=100`);
      if (!response.ok) throw new Error("Something went wrong!");
      const data = await response.json();
      dispatch(httpActions.addPromoItems(data.awards))
    };
    await fetchData().catch((error) => console.log(error.msg));
  };
};

export const getPromoTemplate = (language) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await fetch(process.env.REACT_APP_SERVER + "/api/v2/promotion-templates");
      const data = await response.json();
      const defaultTemplate = data.templates.sort((a, b) => b.startAt - a.startAt);

      dispatch(httpActions.setPromoTemplate(defaultTemplate));

    }
    await fetchData();
  }
}
